module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-door-horizontal-top.60cef658.png";